import { Action, createReducer, on } from '@ngrx/store';

import * as actions from './articles.actions';
import { ArticlesState, initialArticlesState } from './articles.state';

const articlesReducer = createReducer(
    initialArticlesState,
    on(actions.loadArticlesSuccess, (state, action) => ({ ...state, articles: action.articles })),
    on(actions.loadArticlesFailed, (state, action) => ({ ...state, articles: [], error: action.error })),
    on(actions.loadAdminArticles, state => ({ ...state, loading: true })),
    on(actions.loadAdminArticlesSuccess, (state, action) => ({ ...state, articles: action.articles, loading: false })),
    on(actions.loadAdminArticlesFailed, (state, action) => ({ ...state, articles: [], error: action.error, loading: false })),
    on(actions.createArticle, (state, action) => ({ ...state, article: action.article, loading: true })),
    on(actions.createArticleSuccess, (state, action) => ({ ...state, article: action.article, loading: false, updateArticleSuccess: true })),
    on(actions.createArticleFailed, (state, action) => ({
        ...state,
        articleError: action.error,
        loading: false,
    })),
    on(actions.updateArticle, state => ({ ...state, loading: true })),
    on(actions.updateArticleSuccess, (state, action) => ({ ...state, article: action.article, loading: false, updateArticleSuccess: true })),
    on(actions.updateArticleFailed, (state, action) => ({
        ...state,
        articleError: action.error,
        loading: false,
    })),
    on(actions.deleteArticle, state => ({ ...state, loading: true })),
    on(actions.deleteArticleSuccess, state => ({ ...state, loading: false, deleteArticleSuccess: true })),
    on(actions.deleteArticleFailed, (state, action) => ({ ...state, articleError: action.error, loading: false })),
    on(actions.getArticle, state => ({ ...state, loading: true })),
    on(actions.getArticleSuccess, (state, action) => ({ ...state, article: action.article, loading: false })),
    on(actions.getArticleFailed, (state, action) => ({ ...state, articleError: action.error, loading: false })),
    on(actions.resetError, state => ({ ...state, error: false })),
    on(actions.resetArticleError, state => ({ ...state, articleError: false })),
    on(actions.resetUpdateArticleSuccess, state => ({ ...state, updateArticleSuccess: false })),
    on(actions.resetDeleteArticleSuccess, state => ({ ...state, deleteArticleSuccess: false })),
    on(actions.deleteArticleSuccess, state => ({ ...state, deleteArticleSuccess: true })),
);

export function reducer(state: ArticlesState | undefined, action: Action) {
    return articlesReducer(state, action);
}
